<template>
  <div id="layout-header">
    <div class="header">
      <div class="d-flex align-items-center gap-5">
        <div>
          <router-link :to="{ name: 'home' }">
            <img
              :src="require('@/assets/images/logo.svg')"
              alt="writers BASE"
              height="50"
            />
          </router-link>
        </div>
        <div>
          <p class="title-logo">制作メニュー</p>
        </div>
      </div>
      <div class="list-menu">
        <ul class="d-flex mb-0 list-unstyled">
          <li v-if="helper.checkRoles('home') && showButton">
            <router-link
              class="d-flex align-items-center gap-1"
              :to="{ name: 'home' }"
            >
              <span>HOME</span>
            </router-link>
          </li>
          <BaseButton
            v-if="helper.checkRoles('home') && showButton"
            title="前に戻る"
            class="logout-btn"
            @click="GoBack()"
          />
          <li v-if="helper.checkRoles('article.create') && showButton">
            <router-link
              class="d-flex align-items-center gap-1"
              to="/article#create"
            >
              <span>原稿を書く </span>
            </router-link>
          </li>
          <BaseButton
            v-if="helper.checkRoles('home') && showButton"
            title="記事を読む"
            class="logout-btn"
            @click="goToWordPress()"
          />
          <BaseButton
            v-if="helper.checkRoles('home') && showButton"
            title="ヘルプ"
            class="logout-btn"
            @click="goToHelp()"
          />
          <BaseButton
            v-if="helper.checkRoles('home') && showButton"
            title="ログアウト"
            class="logout-btn"
            @click="helper.logoutWp()"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/shared/BaseButton.vue';
import helper from '@/utils/helper';
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';
const route = useRoute();
const router = useRouter();
const showButton = computed(() => !['invite.confirm'].includes(String(route.name)));

const goToWordPress = () => {
  window.open(process.env.VUE_APP_ENDPOINT_WP, '_blank', 'noopener,noreferrer');
};

const goToHelp = () => {
  window.location.href = process.env.VUE_APP_HELP_URL;
};

const GoBack = () => {
  router.back();
};
</script>

<style scoped lang="scss">
@import '@/assets/css/header.scss';
</style>
